import jQuery from 'jquery';

import axios from 'axios';
import _ from 'lodash';
import * as dateHelper from '../dateHelper';
import * as dateFns from 'date-fns';
import * as deLocale from 'date-fns/locale/de';

window.$ = jQuery;
window.jQuery = jQuery;

window._ = _;

window.axios = axios;
window.dateHelper = dateHelper;
window.dateFns = dateFns;
window.deLocale = deLocale;
